/**
 * 価格帯を設定する定数priceRangeを定義
 */
export const priceRange = {
  p0: { min: 0, max: 0},
  p5000: { min: 1, max: 5000},
  p10000: { min: 5001, max: 10000},
  p20000: { min: 10001, max: 20000},
  p30000: { min: 20001, max: 30000},
  p30001: { min: 30001, max: Number.MAX_VALUE}
}